import { Icon, Link, useTheme, getId } from '@fluentui/react';
import React from 'react';
import { LinkOpenNewTabDescription } from './LinkOpenNewTabDescription';

interface ILinkOpenNewTabProps {
  readonly href: string;
}

export const LinkOpenNewTab: React.FC<ILinkOpenNewTabProps> = ({ href, children }) => {
  const theme = useTheme();
  const externalLinkDescriptionId = getId();
  return (
    <>
      <Link href={href} target="_blank" aria-describedby={externalLinkDescriptionId}>
        {children}
        <Icon
          styles={{
            root: {
              marginLeft: 6,
              color: theme.palette.themePrimary,
            },
          }}
          iconName="OpenInNewTab"
        />
        <LinkOpenNewTabDescription id={externalLinkDescriptionId} />
      </Link>
    </>
  );
};
